<template lang="pug">
textarea(v-model="value" @keyup="onKeyup")
</template>

<script setup lang="ts">
import { useUserNotes } from '@/store/useUserNotes';
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { debounce } from 'lodash';

const props = defineProps<{uid: string}>();

const userNotes = useUserNotes();

const value = ref('');

const onKeyup = debounce(async () => await userNotes.setNotes(props.uid, value.value), 1000)

onMounted(async () => {value.value = await userNotes.getNotes(props.uid)});
onUnmounted(async () => {await userNotes.setNotes(props.uid, value.value)});
watch(() => props.uid, async (next, prev) => {
    const current = value.value;
    value.value = '';
    value.value = await userNotes.getNotes(next);
    await userNotes.setNotes(prev, current);
})

</script>

<style scoped lang="scss">
textarea {
    width: 100%;
    min-height: 8em;
    font-family: unset;
    resize: vertical;
}
</style>